// FEATURED COLLECTION (namespace .s-featured)
// - Quick add com fetch
// - Abertura instantânea do cart drawer (Halo)
// - Proteção contra duplicação (LOCK GLOBAL)

(function () {

  // 🔒 LOCK GLOBAL — impede add duplicado por race condition
  if (window.__FEATURED_QUICK_ADD_LOADED__) return;
  window.__FEATURED_QUICK_ADD_LOADED__ = true;

  window.__FEATURED_ADD_IN_PROGRESS__ = false;

  function openCartDrawer() {
    var openBtn =
      document.querySelector('[data-open-cart-sidebar]') ||
      document.querySelector('[data-cart-toggle]');

    if (openBtn) {
      openBtn.click();
      return;
    }

    // Fallback mínimo
    document.body.classList.add('open-cart-sidebar');
  }

  function initQuickAdd(section) {
  var forms = section.querySelectorAll('.s-featured__quick-add-form');
  if (!forms.length) return;

  forms.forEach(function (form) {
    var submitButton = form.querySelector('[data-quick-add-button]');
    if (!submitButton) return;

    var label = submitButton.querySelector('.s-featured__cta-label');
    var defaultLabel = label ? label.textContent : 'Comprar';

    function setLoading() {
      submitButton.classList.add('is-loading');
      if (label) label.textContent = 'Adicionando...';
    }

    function resetLoading() {
      submitButton.classList.remove('is-loading');
      if (label) label.textContent = defaultLabel;
    }

    form.addEventListener('click', function (e) {
      e.stopPropagation();
    });

    submitButton.addEventListener('click', function (event) {
      event.preventDefault();
      event.stopPropagation();

      if (submitButton.classList.contains('is-loading')) return;
      if (window.__FEATURED_ADD_IN_PROGRESS__) return;

      window.__FEATURED_ADD_IN_PROGRESS__ = true;

      if (!window.fetch) {
        window.__FEATURED_ADD_IN_PROGRESS__ = false;
        return;
      }

      var formData = new FormData(form);
      var variantId = formData.get('id');

      if (!variantId) {
        console.error('[FEATURED] Variant ID inválido');
        window.__FEATURED_ADD_IN_PROGRESS__ = false;
        return;
      }

      // 🔥 loading instantâneo + drawer
      setLoading();
      openCartDrawer();

      fetch('/cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json'
        },
        body: JSON.stringify({
          id: variantId,
          quantity: 1
        })
      })
        .then(function (res) {
          if (!res.ok) {
            return res.json().then(function (data) {
              throw new Error(
                (data && (data.description || data.message)) ||
                'Erro ao adicionar produto ao carrinho.'
              );
            });
          }

          return res.json();
        })
        .then(function () {
          if (typeof Shopify !== 'undefined' && Shopify.getCart) {
            Shopify.getCart(function (cart) {
              if (typeof window.updateCart === 'function') {
                window.updateCart(cart);
              }
            });
          }
        })
        .catch(function (err) {
          console.error('[FEATURED] Erro no quick add:', err);
        })
        .finally(function () {
          resetLoading();
          window.__FEATURED_ADD_IN_PROGRESS__ = false;
        });
    });
  });
}

  function initReveal(section) {
    if (!section.classList.contains('s-featured--reveal')) return;

    if (!('IntersectionObserver' in window)) {
      section.querySelectorAll('.s-featured__card').forEach(function (card) {
        card.classList.add('is-visible');
      });
      return;
    }

    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add('is-visible');
            observer.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.15 }
    );

    section.querySelectorAll('.s-featured__card').forEach(function (card) {
      observer.observe(card);
    });
  }

  function initCouponCopy(section) {
    const buttons = section.querySelectorAll('.s-featured__coupon-badge');
    if (!buttons.length) return;

    buttons.forEach((btn) => {
      const codeEl = btn.querySelector('.s-featured__coupon-code');
      const originalCode = codeEl ? codeEl.textContent : '';

      btn.addEventListener('click', () => {
        const coupon = btn.getAttribute('data-coupon');
        if (!coupon) return;

        navigator.clipboard.writeText(coupon).then(() => {
          btn.classList.add('is-copied');

          const labelEl = btn.querySelector('.s-featured__coupon-label');

          if (labelEl) {
            labelEl.textContent = 'CUPOM';
          }

          if (codeEl) {
            codeEl.textContent = 'COPIADO';
          }

          setTimeout(() => {
            btn.classList.remove('is-copied');

            if (labelEl) {
              labelEl.textContent = 'CUPOM';
            }

            if (codeEl) {
              codeEl.textContent = originalCode;
            }
          }, 2000);
        });
      });
    });
  }  

  // ==============================
  // CARROSSEL DESKTOP – NAVEGAÇÃO
  // ==============================
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('.s-featured__nav-btn');
    if (!btn) return;

    var section = btn.closest('.s-featured');
    if (!section) return;

    var list = section.querySelector('.s-featured__list');
    var card = list && list.querySelector('.s-featured__card');
    if (!list || !card) return;

    var styles = window.getComputedStyle(list);
    var gap = parseInt(styles.columnGap || styles.gap || 0, 10);

    var cardsPerView = 4; // desktop fixo
    var scrollAmount = (card.offsetWidth + gap) * cardsPerView;

    list.scrollBy({
      left: btn.classList.contains('is-next') ? scrollAmount : -scrollAmount,
      behavior: 'smooth',
    });
  });


document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('.s-featured').forEach(function (section) {
    initQuickAdd(section);
    initReveal(section);
    initCouponCopy(section); // 👈 ADICIONAR AQUI
  });
});

})();


